/**
 * Declared-VAT helpers shared by the expense form, the journal modal and the
 * expanded panels (docs/TAX.md "Edit guard").
 *
 * A document is *declared* once any of its ledger lines carries a
 * `vat_settlement_id` — the tag `file_vat_return` stamps on every VAT line of
 * the filed period. The slim index views expose the same fact as
 * `vat_declared_settlement_id`; the forms derive it from the detail they
 * already load (expense line items, `useLedgerTransactionEntries`, the AR
 * document's `entries(*)`), which is what this helper reads.
 */

/**
 * The settlement id of the first tagged line, or null when nothing on the
 * document has been declared.
 *
 * One id is enough: it gates the frozen inputs and names the filed period in
 * the banner. A transaction *can* carry lines tagged to two settlements (a
 * supplementary return sweeping a late line into a later period), and then
 * the label names whichever tag comes first — the user still sees "declared"
 * and still gets the header-only save; the exact period is informational.
 */
export function declaredSettlementIdOf(
  entries:
    | ReadonlyArray<{ vat_settlement_id?: string | null } | null | undefined>
    | null
    | undefined,
): string | null {
  if (!entries) return null;
  for (const entry of entries) {
    if (entry?.vat_settlement_id) return entry.vat_settlement_id;
  }
  return null;
}
